import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import { FormattedMessage, useIntl } from 'react-intl';
import TelematicsName from '../TelematicsName';
import type { Device } from '../types';

export type DeviceListDeletionDialogProps = {
    devicesToDisassociate: Device[];
    displayDeviceDeleteDialog: boolean;
    disassociateDevices: (devices: Device[]) => () => void;
    abortDelete: () => void;
};
export const DeviceListDeletionDialog = (props: DeviceListDeletionDialogProps) => {
    const intl = useIntl();
    const isSingleDevice = props.devicesToDisassociate.length === 1;

    const deletionModalContent = (
        <>
            <p>
                <FormattedMessage
                    id={
                        isSingleDevice
                            ? 'intl-msg:association.delete-confirmation-dialog.content.part1.one'
                            : 'intl-msg:association.delete-confirmation-dialog.content.part1.other'
                    }
                />
            </p>
            <ul>
                {props.devicesToDisassociate.map(it => (
                    <li key={it.id}>
                        <b>
                            <TelematicsName deviceType={it.type} />:
                        </b>{' '}
                        {it.identification}
                    </li>
                ))}
            </ul>
            <p>
                <FormattedMessage
                    id={
                        isSingleDevice
                            ? 'intl-msg:association.delete-confirmation-dialog.content.part2.one'
                            : 'intl-msg:association.delete-confirmation-dialog.content.part2.other'
                    }
                />
            </p>
        </>
    );

    return props.displayDeviceDeleteDialog ? (
        <ConfirmationDialog
            show={props.displayDeviceDeleteDialog}
            title={intl.formatMessage({ id: 'intl-msg:asset.device-delete-confirmation-dialog.title' })}
            bsSize={'sm'}
            content={deletionModalContent}
            onClickConfirm={props.disassociateDevices(props.devicesToDisassociate)}
            onClickCancel={props.abortDelete}
            cancelButtonText={<FormattedMessage id={'intl-msg:asset.delete-confirmation-dialog.button.cancel'} />}
            confirmButtonText={<FormattedMessage id={'intl-msg:asset.delete-confirmation-dialog.button.confirm'} />}
            disableConfirm={false}
            useOverflow={true}
        />
    ) : null;
};
